import script from "./SalonDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SalonDetail.vue?vue&type=script&setup=true&lang=js"

import "./SalonDetail.vue?vue&type=style&index=0&id=0ad7796a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad7796a"]])

export default __exports__